<template>
    <FullFillBox
        :pageID="10"
        @permissionData="(data) => {
                this.permissionDetails = data
            }"
    >
        <h4>{{ title }}</h4>
        <div v-if="!wrongParams">
            <div class="rap-image" style="margin: 10px">
                <img :src="simpleImageSrc" alt="excel_format_simple" style="height: 80%">
            </div>
            <p>
                {{ $t('product_upload_select_file') }}
                <span>
                    <input type="file" @change="selectExcelFile($event)"
                           accept=".xls,.xlsx" id="inputExcel">
                </span>
                <button class="btn btn-primary" v-if="getInputExcel" @click="uploadExcel('review')">
                    {{ $t('common_review') }}
                </button>
            </p>
            <hr>
            <p class="error-text" v-if="errorTitle">{{ errorTitle }}</p>
            <div class="rag-image" id="tableDiv">
                <h6 class="error-text">
                    <span style="color: black">{{ $t('product_upload_total_row') }} {{ excelTotalRow }} ;</span>
                    {{ excelDetails }}
                </h6>
                <p>
                    <button class="btn btn-warning" type="button"
                            data-bs-toggle="collapse" data-bs-target="#collapseExample"
                            aria-expanded="false" aria-controls="collapseExample">
                        {{ $t('error_expand_error_details') }}
                    </button>
                </p>
                <div class="collapse" id="collapseExample">
                    <div v-if="isError">
                        <div v-for="(value, key) in excelRowDetails">
                            <div class="row" style="border: #2c3e50 1px solid">
                                <div class="col-4"><p>{{ $t('common_row') }} : {{ value['row'] }}</p></div>
                                <div class="col-8">
                                    <h6>{{ value['errors'] }}</h6>
                                    <p v-for="(v, k) in value['details']">
                                        <span><strong>{{ k + 1 }}</strong></span> :
                                        <span class="error-text" v-for="(v2, k2) in v"> {{ k2 }} : {{ v2 }} ;</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <hr>
                <button class="btn btn-primary" type="button"
                        @click="uploadExcel('upload')" id="common_upload"
                        style="margin: auto"
                >
                    {{ $t('common_upload') }}
                </button>
                <hr>
                <div ref="tabulatorTableUse"></div>
            </div>
        </div>
    </FullFillBox>
</template>

<script>
import FullFillBox from "@/components/routerViewLocation/FullFillBox";
import {TabulatorFull as Tabulator} from "tabulator-tables";

export default {
    name: "OtherDetailsImportExcelView",
    components: {
        FullFillBox,
    },
    data(){
        return {
            permissionDetails: {},
            wrongParams: false,
            getType: '',
            title: '',
            simpleImageSrc: '',
            getInputExcel: '',
            excelTotalRow: '',
            excelDetails: '',
            excelRowDetails: '',
            errorsRowList: '',
            errorTitle: '',
            isError: false,
        }
    },
    watch: {
        '$route.params': {
            async handler(newType) {
                this.reloadChecker(newType)
            },
            immediate: true,
        }
    },
    methods: {
        getHeaderMenu(){
            return this.$getHeaderMenu(this.tabulator)
        },
        delTableItem(getID){
            this.$swal.fire({
                title: this.$t('common_confirm_action_delete'),
                icon: "info"
            }).then((result) => {
                if(result.isConfirmed){
                    this.tabulator.setData(this.tabulator.getData().filter(a => a.id !== getID))
                }
            })
        },
        resetAllDataError(){
            // Reset data
            this.excelDetails = ""
            this.errorTitle = ""
            this.errorsRowList = ""
            this.excelRowDetails = ""
            document.getElementById('tableDiv').style.display = 'none'
            document.getElementById('common_upload').style.display = 'block'
        },
        async processOnReturnData(response){
            document.getElementById('tableDiv').style.display = 'block'
            this.errorsRowList = response.data.errors.errors_row
            this.excelTotalRow = response.data.details.total_row
            this.excelDetails = this.$t('error_error_list')
            for(let e=0;e<this.errorsRowList.length;e++){
                if(e === this.errorsRowList.length-1){
                    this.excelDetails += this.errorsRowList[e]
                }else{
                    this.excelDetails += this.errorsRowList[e] + ", "
                }
            }

            this.tabulator.setData(response.data.details.data)

            this.isError = true
            this.excelRowDetails = response.data.errors.errors_details

        },
        async uploadExcel(getMode) {
            this.$store.commit('setIsTopLoading', true)

            // Reset data
            this.resetAllDataError()

            let postData = {
                "excel": this.getInputExcel,
                "type": this.getType,
                "mode": getMode
            }
            await this.uploadServer(postData)
            this.$store.commit('setIsTopLoading', false)
        },
        async uploadServer(postData){
            await this.$mainApi.post('api/other-details/import/', postData, {
                headers: {
                    "content-type": "multipart/form-data"
                }
            })
                .then(async response => {
                    if (response.data.status === 80) {
                        await this.processOnReturnData(response)
                        if(response.data.errors.errors_row.length === 0 && postData.mode === "upload"){
                            // No Errors and serializer save successfully
                            this.$toast.success(this.$t('common_success'))
                            this.$router.push(`/other-details/${this.getType}`)
                        }else if(response.data.errors.errors_row.length > 0 && postData.mode === "upload"){
                            this.tabulator.setData(this.tabulator.getData().filter(a => this.errorsRowList.includes(a.row)))
                        }
                    } else {
                        this.errorTitle = response.data.errors
                    }
                })
        },
        selectExcelFile(e) {
            this.getInputExcel = e.target.files.item(0)
        },
        reloadChecker(newType){
            if(newType.type === 'location') {
                this.title = this.$t('other_details_location_excel_upload');
                this.getType = newType.type
                this.simpleImageSrc = this.$store.state.serverIp + this.$store.state.serverMediaPath + 'website/images/location_excel_simple.jpg'
            }else if(newType.type === 'driver'){
                this.title = this.$t('other_details_driver_excel_upload');
                this.getType = newType.type
                this.simpleImageSrc = this.$store.state.serverIp + this.$store.state.serverMediaPath + 'website/images/driver_excel_simple.jpg'
            }else if(newType.type === 'department'){
                this.title = this.$t('other_details_department_excel_upload');
                this.getType = newType.type
                this.simpleImageSrc = this.$store.state.serverIp + this.$store.state.serverMediaPath + 'website/images/department_excel_simple.jpg'
            }else{
                this.title = this.$t('error_not_found')
                this.wrongParams = true
            }
        }
    },
    mounted() {
        this.$mainApi.defaults.headers.common['GL-Page-ID'] = "10";
        this.$mainApi.defaults.headers.common['GL-Action-ID'] = "1";
        document.title = this.$t('title') + ' | ' + this.$t('other_details_excel_upload')

        this.tabulator = new Tabulator(this.$refs.tabulatorTableUse, {
            placeholder: "<h3>" + this.$t('common_no_data') + "</h3>",
            data: [],
            columns: [
                {title: 'row', field: 'row', sorter: 'number', resizable:false,
                    width:80, responsive:0,
                    headerFilter:"list",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'id', field: 'id', sorter: 'number', resizable:false,
                    responsive:0,
                    headerFilter:"list",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: this.getType === "location" ? "location" : "name",
                    field: this.getType === "location" ? "location" : "name", sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: this.getType === "location" ? "area" : this.getType === "department" ? "ordering_lv" : "phone",
                    field: this.getType === "location" ? "area" : this.getType === "department" ? "ordering_lv" : "phone",
                    sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'flag', field: 'flag', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, formatter:"tickCross",
                },
                {formatter: () => {return "<i class='bi bi-trash-fill'></i>"},
                    headerHozAlign:"center", hozAlign:"center", vertAlign: "middle", resizable:false,
                    headerMenu: this.getHeaderMenu,
                    headerSort:false, width:10, responsive:0,
                    cellClick: (e, row, formatterParams) => {
                        this.delTableItem(row.getData().id)
                    }
                },
            ],
            reactiveData: true, //enable data reactivity
            maxHeight: '90vh',
            responsiveLayout: 'collapse',
            layout: "fitColumns",
            movableColumns:true,
            movableRows: false,
            initialSort: [
                {column:"row", dir:"asc"},
            ],
            rowFormatter: (row, e) => {
                if(row.getData().is_error === true){
                    row.getElement().style.backgroundColor = "#fac3c3"
                }
            }
        })
        document.getElementById('tableDiv').style.display = 'none'
    }
}
</script>

<style scoped>

</style>
